module.exports = __webpack_public_path__ + "img/1F1F5-1F1F0.0b8f644b.svg";